@if (model) {
    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'apiKeyDetail.basicDetailsTitle' | t }}</div>
        <div class="detail-page-card-body padded form-group-styling">
            <div class="form-group">
                <label>{{ 'apiKeyDetail.nameLabel' | t }}</label>
                <cerrix-textfield
                    dataUiid="apikey-name"
                    [placeholder]="'apiKeyDetail.namePlaceholder' | t"
                    [(ngModel)]="model.name"
                    [disabled]="readonly"
                >
                </cerrix-textfield>
            </div>
            <div class="form-group">
                <label>{{ 'apiKeyDetail.expirationDateLabel' | t }}</label>
                <date-input
                    [(value)]="model.expirationDate"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [disabled]="readonly"
                ></date-input>
            </div>
        </div>
    </div>

    @if (softIpRequestedConfig) {
        <generic-list-manager
            data-uiid="api-soft-ip-requested"
            [config]="softIpRequestedConfig"
        ></generic-list-manager>
    }

    @if (softIpAllowedConfig) {
        <generic-list-manager
            data-uiid="api-soft-ip-allowed"
            [config]="softIpAllowedConfig"
        ></generic-list-manager>
    }

    @if (softIpDeniedConfig) {
        <generic-list-manager
            data-uiid="api-soft-ip-denied"
            [config]="softIpDeniedConfig"
        ></generic-list-manager>
    }

    @for (module of model.keysByModule; track module) {
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ module.name }}</div>
            <div class="detail-page-card-body padded form-group-styling">
                @for (group of module.groups; track group; let i = $index) {
                    @if (i > 0) {
                        <hr />
                    }
                    @if (group.name) {
                        <div class="group-info">
                            <label>{{ group.name }}</label>
                            <small class="text-muted">{{ group.description }}</small>
                        </div>
                    }
                    <div class="keys">
                        @for (access of group.keys; track access) {
                            <div class="key-option">
                                <span>
                                    <cerrix-checkbox
                                        [attr.data-uiid]="'apikey-access-' + access.apiKey"
                                        [(value)]="access.selected"
                                        [label]="access.name"
                                        [disabled]="readonly || access.readOnly"
                                        fontsize="0.9em"
                                    >
                                    </cerrix-checkbox>
                                    <i
                                        class="fas fa-question-circle ms-2"
                                        (click)="openManual(access, module.moduleKey)"
                                    ></i>
                                </span>
                                <small
                                    class="text-muted text-truncate"
                                    [title]="access.description"
                                    >{{ access.description }}</small
                                >
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
}
